import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import {
  ButtonComponent,
  InputComponent,
  MobileNumberComponent,
  SelectComponent,
} from '@app-ui';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import {
  BaseComponent,
  COMPANY_SIZE,
  CompanyDetails,
  CompanySize,
  CountryItem,
  CountryStateCityService,
  INDUSTRY_OPTIONS,
  IndustryOption,
} from '@app-utils';
import { AuthFlowService } from '../../services';
import { takeUntil } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

/**
 *
 */
@Component({
  selector: 'auth-register-details',
  templateUrl: './register-details.component.html',
  styleUrl: './register-details.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AsyncPipe,
    ButtonComponent,
    SelectComponent,
    FormsModule,
    InputComponent,
    NgIf,
    NgFor,
    ReactiveFormsModule,
    RouterLink,
    MobileNumberComponent,
    TranslateModule,
  ],
})
export class RegisterDetailsComponent extends BaseComponent implements OnInit {
  private readonly _csc = inject(CountryStateCityService);
  readonly authFlowSvc = inject(AuthFlowService);

  @Input() initialStep: 0 | 1 | 2 | 3 | 4 | 5 | 6 = 0;

  @Input() loading = false;

  @Input() removeUserName = false;

  @Output() completeDetails = new EventEmitter<CompanyDetails>();

  @Output() allBack = new EventEmitter<void>();

  countryList: CountryItem[] = [];

  sizeList: CompanySize[] = [...COMPANY_SIZE];

  industryList: IndustryOption[] = [...INDUSTRY_OPTIONS];

  selectedCountry: string = '';

  company: CompanyDetails = {
    orgName: '',
    firstName: '',
    lastName: '',
    country: '',
    phoneNumber: '',
    numOfEmp: '',
    industry: '',
  };
  order = ['name', 'size', 'industry', 'fn', 'ln', 'country', 'phoneNumber'];
  currentStep = {
    step: 'name',
    index: 0,
  };

  phoneValidationError = false

  ngOnInit(): void {
    this.currentStep = {
      step: this.order[this.initialStep],
      index: this.initialStep,
    };

    if (this.removeUserName) {
      this.order = ['name', 'size', 'industry', 'country', 'phoneNumber'];
    }

    this.company.orgName = this.authFlowSvc.getCompanyDetail()?.orgName || '';
    this.company.numOfEmp = this.authFlowSvc.getCompanyDetail()?.numOfEmp || '';
    this.company.industry =
      this.authFlowSvc.getCompanyDetail()?.industry || '';
    this.company.firstName =
      this.authFlowSvc.getCompanyDetail()?.firstName || '';
    this.company.lastName = this.authFlowSvc.getCompanyDetail()?.lastName || '';
    this.company.country = this.authFlowSvc.getCompanyDetail()?.country || '';
    this.company.phoneNumber =
      this.authFlowSvc.getCompanyDetail()?.phoneNumber || '';

    this._csc.countries$.pipe(takeUntil(this._destroy$)).subscribe((res) => {
      this.countryList = res;
    });
  }

  goToNext(): void {
    if (this.isDisable) return;
    if (this.currentStep.index === this.order.length - 1) {
      this.completeDetails.emit({
        orgName: this.company.orgName.trim(),
        firstName: this.company.firstName.trim(),
        lastName: this.company.lastName.trim(),
        country: this.company.country.trim(),
        phoneNumber: this.company.phoneNumber.trim(),
        numOfEmp: this.company.numOfEmp.trim(),
        industry: this.company.industry?.trim() || '',
      });
      return;
    }
    if (this.currentStep.index > this.order.length - 1) return;
    this.currentStep.index++;
    this.currentStep.step = this.order[this.currentStep.index];
    console.log('========next');
  }

  goToBack(): void {
    if (this.currentStep.index <= this.initialStep) {
      this.allBack.emit();
      return;
    }
    this.currentStep.index--;
    this.currentStep.step = this.order[this.currentStep.index];
    console.log('========back');
  }

  get isDisable(): boolean {
    if (this.currentStep.step === 'name') {
      return !this.company?.orgName?.trim();
    }
    if (this.currentStep.step === 'size') {
      return !this.company?.numOfEmp;
    }
    if (this.currentStep.step === 'industry') {
      return !this.company?.industry?.trim();
    }
    if (this.currentStep.step === 'fn') {
      return !this.company?.firstName?.trim();
    }
    if (this.currentStep.step === 'ln') {
      return !this.company?.lastName?.trim();
    }
    if (this.currentStep.step === 'country') {
      return !this.company?.country;
    }
    if (this.currentStep.step === 'phoneNumber') {
      return (
        (this.company?.phoneNumber?.trim() || '').replace(
          this.selectedCountry,
          '',
        ).length < 8
      );
    }
    return false;
  }
}
